import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from "prop-types";

var defaults = require("lodash/defaults");

import { SearchkitComponent, ViewOptionsAccessor, RenderComponentPropType } from "../../../core";
export var ViewSwitcherConfig =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(ViewSwitcherConfig, _SearchkitComponent);

  function ViewSwitcherConfig() {
    _classCallCheck(this, ViewSwitcherConfig);

    return _possibleConstructorReturn(this, _getPrototypeOf(ViewSwitcherConfig).apply(this, arguments));
  }

  _createClass(ViewSwitcherConfig, [{
    key: "defineAccessor",
    value: function defineAccessor() {
      return new ViewOptionsAccessor("view", this.props.hitComponents);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ViewSwitcherConfig;
}(SearchkitComponent);
ViewSwitcherConfig.propTypes = defaults({
  hitComponents: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    itemComponent: RenderComponentPropType,
    listComponent: RenderComponentPropType,
    defaultOption: PropTypes.bool
  }))
}, SearchkitComponent.propTypes);